/* eslint-disable */
import React from "react";
import { Icon, VideoField } from "@culturehq/components";

import { useProfile } from "app/context";
import { Trans } from "app/utils";
import CameraRecorder from "./CameraRecorder";

const VideoOptions = ({ handleOnMediaChange }) => {
  const { profile: { organization } } = useProfile();
  return (
    <div className="Video-Buttons">
      <VideoField
        className="media-btn"
        name="story-image"
        onChange={(
          media,
          thumb,
          _gifUrl,
          _duration,
          _finalVersion,
          isRecordedVideo
        ) => handleOnMediaChange({ media, thumb, isRecordedVideo })}
        required
        asButtonView
      />
      <CameraRecorder
        organization={organization}
        className="instructional-video-btn"
        onVideoRecorded={handleOnMediaChange}
      >
        <Icon icon="video-camera-filled" />
        <Trans>Record video</Trans>
      </CameraRecorder>
    </div>
  )
};

export default VideoOptions;
